import { useState, useEffect } from 'react';
import { SHOW_ALL } from '../../../i18n/keyConstants';

const searchParams = new URLSearchParams(window.location.search);
const queryFilters = searchParams.get('filters');
const parsedQueryFilters = JSON.parse(queryFilters) || [];

const getFilterValue = (filters, columnName) => {
    const filter = filters.find((filter) => filter.columnName === columnName);
    return filter ? filter.value.split('"').join('') : '';
    //only filter.value?
};

const selectedOfficeValue = () => {
    const office = getFilterValue(parsedQueryFilters, 'office');
    return { office };
};

const selectedRegionValue = () => {
    const regionName = getFilterValue(parsedQueryFilters, 'regionName');
    return { regionName };
};

const generateSelectedArray = (selected, type) => {
    return Object.values(selected[type].split('OR'))
        .filter((city) => city.trim() !== '') // filter out empty strings
        .map((city) => ({
            value: city,
            label: city,
        }));
};

export const selectedValue = () => {
    const empName = getFilterValue(parsedQueryFilters, 'empName');
    const empSkill = getFilterValue(parsedQueryFilters, 'empSkill');
    return { empName, empSkill };
};

export const officesArr = generateSelectedArray(selectedOfficeValue(), 'office');
export const regionArr = generateSelectedArray(selectedRegionValue(), 'regionName');

const HandleCustomChange = (selected, filter, columnName, filters, selectedCheck, dispatch) => {
    selectedCheck(selected);

    var check = false;
    var newFilters = [...filters];

    if (filter) {
        for (var k = 0; k < filters.length; k++) {
            if (newFilters[k].columnName === filter.columnName) {
                newFilters[k].operation = filter.operation;
                newFilters[k].value = filter.value;
                check = true;
            }
        }

        if (check) {
            dispatch({ type: 'FILTERS', payload: newFilters });
        } else {
            dispatch({ type: 'FILTERS', payload: filters.concat([filter]) });
        }
    } else {
        for (var l = 0; l < filters.length; l++) {
            if (newFilters[l].columnName === columnName) {
                newFilters.splice(l, 1);
                break;
            }
        }

        dispatch({ type: 'FILTERS', payload: newFilters });
    }
};

export const HandleExlFilter = (option, filters, selectedCheck, columnName, operation, userId, dispatch) => {
    const value = option.value;
    const newFilter = { columnName: columnName, operation: operation, value: userId !== '' ? userId : value };
    HandleCustomChange(option, newFilter, columnName, filters, selectedCheck, dispatch);
}

export const HandleStatusOptions = (options, filters, selectedStatus, selectedCheck, dispatch) => {
    let selectedOptions = options;
    if (selectedStatus && selectedOptions && selectedStatus.some((option) => option.value === 'showAll')) {
        selectedOptions = options.filter((option) => option.value !== 'showAll');
    } else if (!options || options.length > 2 || options.some((option) => option.value === 'showAll')) {
        selectedOptions = [{ value: 'showAll', label: SHOW_ALL }];
    }
    dispatch({ type: 'SELECTED_STATUS', payload: selectedOptions });

    const value = [...new Set(selectedOptions.map((option) => option.value))].join('OR');
    const statusFilter = { columnName: 'status', operation: 'equal', value: value };
    HandleCustomChange(selectedOptions, statusFilter, 'status', filters, selectedCheck, dispatch);
};
export const HandleCourseStatusOptions = (options, filters, selectedStatus, selectedCheck, dispatch) => {
    let selectedOptions = options;
    if (selectedStatus && selectedOptions && selectedStatus.some((option) => option.value === 'showAll')) {
        selectedOptions = options.filter((option) => option.value !== 'showAll');
    } else if (!options || options.length > 4 || options.some((option) => option.value === 'showAll')) {
        selectedOptions = [{ value: 'showAll', label: SHOW_ALL }];
    }
    dispatch({ type: 'SELECTED_COURSE_STATUS', payload: selectedOptions });

    const value = [...new Set(selectedOptions.map((option) => option.value))].join('OR');
    const statusFilter = { columnName: 'status', operation: 'equal', value: value };
    HandleCustomChange(selectedOptions, statusFilter, 'status', filters, selectedCheck, dispatch);
};

export const HandleCustomOptions = (options, filters, columnName, selectedCheck, dispatch) => {
    let selectedOptions = options;

    let value = '';

    if (selectedOptions) {
        value = [...new Set(selectedOptions.map((option) => option.value))].join('OR');
    }
    let filter;

    if (!(value === '')) {
        filter = { columnName, operation: 'equal', value: value };
    } else {
        filter = null;
    }

    HandleCustomChange(selectedOptions, filter, columnName, filters, selectedCheck, dispatch);
};

export const InputDebouncer = (column, filters, chosenValue, intervalRef, children, dispatch) => {
    let newFilters = [...filters];

    let standardOperation;

    if(children[0] === null) {
        switch(column.name) {
            case 'numBookings':
                standardOperation = 'greaterThanOrEqual';
                break;
            default: 
                standardOperation = 'contains';
                break;
        }
    }

    if (chosenValue) {
        intervalRef.current = setTimeout(() => {
            const filterChange = [
                {
                    columnName: column.name,
                    operation: children[0] !== null ? children[0].props.value : standardOperation,
                    value: chosenValue,
                },
            ];
            var check = false;
            
            newFilters.forEach((element) => {
                if (element.columnName === column.name) {
                    element.value = chosenValue;
                    element.operation = children[0] !== null ? children[0].props.value : standardOperation;
                    check = true;
                }
            });

            if (!check) {
                newFilters = newFilters.concat(filterChange);
            }

            filterUpdater(newFilters, column, chosenValue, dispatch).then((res) => {});
        }, 1000);
    } else {
        let newFilters = [...filters];

        for (var x = 0; x < newFilters.length; x++) {
            if (newFilters[x].columnName === column.name) {
                newFilters.splice(x, 1);
                break;
            }
        }

        if (filters.length !== newFilters.length) {
            dispatch({ type: 'FILTERS_AND_SELECTED_FILTERS', payload: newFilters, columnName: column.name, columnNameVal: chosenValue });
        }

        clearTimeout(intervalRef.current);
    }
    return () => clearTimeout(intervalRef.current);
};

// Used for descriptionfilters
export const useDebounce = (values, delay) => {
    const [debouncedValues, setDebouncedValues] = useState(values);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValues(values);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values]);

    return debouncedValues;
};

function filterUpdater(newFilters, column, chosenValue, dispatch) {
    dispatch({ type: 'FILTERS_AND_SELECTED_FILTERS', payload: newFilters, columnName: column.name, columnNameVal: chosenValue });
    return new Promise((resolve, reject) => {
        if (true) {
            resolve();
        } else {
            reject();
        }
    });
}
